/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_DescriptionInputs */

const zh_learn_description = /** @type {(inputs: Learn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索这个交互式 StudyOS 学习资源。`)
};

const en_learn_description = /** @type {(inputs: Learn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore this interactive StudyOS learning resource.`)
};

const es_learn_description = /** @type {(inputs: Learn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora este recurso interactivo de aprendizaje de StudyOS.`)
};

/**
* | output |
* | --- |
* | "Explore this interactive StudyOS learning resource." |
*
* @param {Learn_DescriptionInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_description = /** @type {((inputs?: Learn_DescriptionInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_DescriptionInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_description(inputs)
	if (locale === "en") return en_learn_description(inputs)
	return es_learn_description(inputs)
});